import React from 'react'
import { RouteConstants } from '../../../setup/routeConstants'
import {
	ACCESS_EVENTS_LIST_PAGE, ACCESS_LISTING_INVOICES, ACCESS_LISTING_LIST, DEVELOPER_ACCESS, ACCESS_SELLER_CONTENT_PAGE,
	EDIT_INTEGRATION_SETTINGS, ACCESS_LISTING_USER_PERMISSIONS_TAB,
} from '../../../auth/policies'
import LazyProtectedRoute from '../../LazyProtectedRoute'
import Development from '../../../components/Partners/Listing/Tabs/Development'
import OffersTab from '../../../components/Partners/Listing/Tabs/Offers'
import { Redirect } from 'react-router-dom'
import GovXIDTab from '../../../components/Partners/Listing/Tabs/GovXID'
import OpenIdConnectSection from '../../../components/Partners/Listing/Tabs/GovXID/OpenIdConnectSection'
import MessagingForm from '../../../components/Partners/Listing/Tabs/GovXID/Forms/MessagingSectionForm'
import TemplateSection from '../../../components/Listings/Listing/Tabs/Settings/TemplateSection'
import CredentialsSection from '../../../components/Listings/Listing/Tabs/Deploy/CredentialsSection'
import LoginSection from '../../../components/Listings/Listing/Tabs/Deploy/LoginSection'
import EmailSection from '../../../components/Listings/Listing/Tabs/Settings/EmailSection'
import DataSharing from '../../../components/Listings/Listing/Tabs/Settings/DataSharingSection'
import RedirectsSection from '../../../components/Listings/Listing/Tabs/Deploy/RedirectsSection'
import OccupationsSection from '../../../components/Listings/Listing/Tabs/Settings/OccupationsSection'
import CampaignsSection from '../../../components/Listings/Listing/Tabs/Deploy/CampaignsSection'
import OAuthSection from '../../../components/Listings/Listing/Tabs/Deploy/OAuthSection'
import SettingsTab from '../../../components/Partners/Listing/Tabs/Settings/SettingsTab'
import BillingSettingsSection from '../../../components/Partners/Listing/Tabs/Billing/BillingSettingsSection'
import SellerTab from '../../../components/Partners/Listing/Tabs/Seller'
import SellerCustomizePageSection from '../../../components/Partners/Listing/Tabs/Seller/SellerCustomizePageSection'
import SellerMarketingAssetsSection from '../../../components/Partners/Listing/Tabs/Seller/SellerMarketingAssetsSection'
import EventsSection from '../../../components/Partners/Listing/Tabs/Offers/EventsSection'
import OffersSection from '../../../components/Partners/Listing/Tabs/Offers/OffersSection'
import BillingTab from '../../../components/Partners/Listing/Tabs/Billing'
import IntegrationsSection from '../../../components/Partners/Listing/Tabs/Settings/Integrations/IntegrationsSection'
import NetSuite from '../../../components/Partners/Listing/Tabs/Development/NetSuite'
import Shopify from '../../../components/Partners/Listing/Tabs/Development/Shopify'
import Billing from '../../../components/Partners/Listing/Tabs/Development/Billing'
import Specs from '../../../components/Partners/Listing/Tabs/Development/Specs'
import OfferSection from '../../../components/Listings/Listing/Tabs/Settings/OffersSection'
import UserPermissionsTab from '../../../components/Partners/Listing/Tabs/Settings/Permissions/UserPermissions'
import Invoices from '../../../components/Partners/Listing/Tabs/Billing/Invoices/Invoices'
import CurrentMonth from '../../../components/Partners/Listing/Tabs/Billing/CurrentMonth'

const PartnersListingComponent = React.lazy(() => import("../../../components/Partners/Listing"))

export default {
	path: RouteConstants.partners.listings.listing.path,
	element: (
		<LazyProtectedRoute
			component={<PartnersListingComponent />}
		/>
	),
	children: [
		{
			path: "",
			element: <LazyProtectedRoute component={<OffersTab />} requiredPolicies={[]} />,
			children: [
				{
					index: true,
					element: <LazyProtectedRoute component={<OffersSection />} requiredPolicies={[]} />,
				},
				{
					path: "offers",
					element: <LazyProtectedRoute component={<OffersSection />} requiredPolicies={[]} />,
				},
				{
					path: "events",
					element: <LazyProtectedRoute component={<EventsSection />} requiredPolicies={[]} />,
				},
			]
		},
		{
			path: "development",
			element: <LazyProtectedRoute component={<Development />} requiredPolicies={[DEVELOPER_ACCESS]} />,
			children: [
				{
					index: true,
					element: <LazyProtectedRoute component={<Specs />} requiredPolicies={[]} />,
				},
				{
					path: "netsuite",
					element: <LazyProtectedRoute component={<NetSuite />} requiredPolicies={[]} />,
				},
				{
					path: "shopify",
					element: <LazyProtectedRoute component={<Shopify />} requiredPolicies={[]} />,
				},
				{
					path: "billing",
					element: <LazyProtectedRoute component={<Billing />} requiredPolicies={[]} />,
				},
				{
					path: "specs",
					element: <LazyProtectedRoute component={<Specs />} requiredPolicies={[]} />,
				},
			],
		},
		{
			path: "offers",
			element: <LazyProtectedRoute component={<OffersTab />} requiredPolicies={[]} />,
			children: [
				{
					index: true,
					element: <LazyProtectedRoute component={<OffersSection />} requiredPolicies={[]} />,
				},
				{
					path: "offers",
					element: <LazyProtectedRoute component={<OffersSection />} requiredPolicies={[]} />,
				},
				{
					path: "events",
					element: <LazyProtectedRoute component={<EventsSection />} requiredPolicies={[]} />,
				},
			]
		},
		{
			path: "govx-id",
			element: <LazyProtectedRoute component={<GovXIDTab />} requiredPolicies={[]} />,
			children: [
				{
					index: true,
					element: <LazyProtectedRoute component={<OccupationsSection />} requiredPolicies={[]} />,
				},
				{
					path: "affiliations",
					element: <LazyProtectedRoute component={<OccupationsSection />} requiredPolicies={[]} />,
				},
				{
					path: "listing-display",
					element: <LazyProtectedRoute component={<TemplateSection />} requiredPolicies={[]} />,
				},
				{
					path: "listing-messaging",
					element: <LazyProtectedRoute component={<MessagingForm isWizard={false} />} requiredPolicies={[]} />,
				},
				{
					path: "campaigns",
					element: <LazyProtectedRoute component={<CampaignsSection />} requiredPolicies={[]} />,
				},
				{
					path: "data-sharing",
					element: <LazyProtectedRoute component={<DataSharing />} requiredPolicies={[]} />,
				},
				{
					path: "email-settings",
					element: <LazyProtectedRoute component={<EmailSection />} requiredPolicies={[]} />,
				},
				{
					path: "offer-page",
					element: <LazyProtectedRoute component={<OfferSection />} requiredPolicies={[]} />,
				},
				{
					path: "oauth-links",
					element: <LazyProtectedRoute component={<OAuthSection />} requiredPolicies={[]} />,
				},
				{
					path: "whitelisted-urls",
					element: <LazyProtectedRoute component={<RedirectsSection />} requiredPolicies={[]} />,
				},
				{
					path: "credentials",
					element: <LazyProtectedRoute component={<CredentialsSection />} requiredPolicies={[]} />,
				},
				{
					path: "govx-login",
					element: <LazyProtectedRoute component={<LoginSection />} requiredPolicies={[]} />,
				},
				{
					path: "openid-connect",
					element: <LazyProtectedRoute component={<OpenIdConnectSection />} requiredPolicies={[DEVELOPER_ACCESS]} />,
				},
			]
		},
		{
			path: "settings",
			element: <LazyProtectedRoute component={<SettingsTab />} requiredPolicies={[]} />,
			children: [
				{
					path: '',
					index: true,
					element: <LazyProtectedRoute component={<IntegrationsSection />} requiredPolicies={[EDIT_INTEGRATION_SETTINGS]} />,
				},
				{
					path: "integrations",
					element: <LazyProtectedRoute component={<IntegrationsSection />} requiredPolicies={[EDIT_INTEGRATION_SETTINGS]} />,
				},
				{
					path: "user-permissions",
					element: <LazyProtectedRoute component={<UserPermissionsTab />} requiredPolicies={[ACCESS_LISTING_USER_PERMISSIONS_TAB]} />,
				}
			]
		},
		{
			path: "seller",
			element: <LazyProtectedRoute component={<SellerTab />} requiredPolicies={[ACCESS_SELLER_CONTENT_PAGE]} />,
			children: [
				{
					path: "",
					element: <LazyProtectedRoute component={<SellerCustomizePageSection />} requiredPolicies={[]} />,
				},
				{
					path: "customize-page",
					element: <LazyProtectedRoute component={<SellerCustomizePageSection />} requiredPolicies={[]} />,
				},
				{
					path: "marketing-assets",
					element: <LazyProtectedRoute component={<SellerMarketingAssetsSection />} requiredPolicies={[]} />,
				},
			]
		},
		{
			path: "partner-billing",
			element: <LazyProtectedRoute component={<BillingTab />} requiredPolicies={[ACCESS_LISTING_INVOICES]} />,
			children: [
				{
					path: '',
					index: true,
					element: <LazyProtectedRoute component={<BillingSettingsSection />} requiredPolicies={[ACCESS_LISTING_INVOICES]} />,
				},
				{
					path: 'edit-terms',
					element: <LazyProtectedRoute component={<BillingSettingsSection />} requiredPolicies={[ACCESS_LISTING_INVOICES]} />,
				},
				{
					path: 'billing-invoices',
					element: <LazyProtectedRoute component={<Invoices />} requiredPolicies={[ACCESS_LISTING_INVOICES]} />,
				},
				{
					path: 'current-month',
					element: <LazyProtectedRoute component={<CurrentMonth />} requiredPolicies={[ACCESS_LISTING_INVOICES]} />,
				},
				{
					path: 'billing-settings/*',
					element: <LazyProtectedRoute component={<BillingSettingsSection />} requiredPolicies={[ACCESS_LISTING_INVOICES]} />,
				}
			]
		},
	]
}